var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vca-card',{staticClass:"shadowed"},[_c('h2',[_vm._v(_vm._s(_vm.$t("overview.dashboard.network")))]),_c('vca-row',[_c('vca-column',[_c('ActiveDashlet'),_c('div',[_c('hr')]),_c('EventConfirmationDashlet'),_c('EventApplicationDashlet'),_c('div',[_c('hr')]),_c('EmailDraftDashlet')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }